/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/32/close': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g class="nc-icon-wrapper" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" _fill="none" _stroke="#272c33" stroke-miterlimit="10"><path pid="0" d="M27 5L5 27M27 27L5 5"/></g>'
  }
})
